import React from 'react'
import { Button } from '@material-ui/core';
import { Link } from "react-router-dom";



class Buttons extends React.Component {
  render() {
    return (
      <div style={{ display: 'flex', width: "100%", flexShrink: 0 }}>
        <Link to="/" style={{ flexGrow: 1, display: "flex", justifyContent: 'center' }}>
          <Button style={{ backgroundColor: '#ccc', flexGrow: 1, margin: '0 10px' }}>
            صفحه اول
                  </Button>
        </Link>
        <Link onClick={() => { this.props.onReload(); }} style={{ flexGrow: 1, display: "flex", justifyContent: 'center' }}>
          <Button style={{ backgroundColor: '#1dc37e', flexGrow: 1, margin: '0 10px', color: '#fff' }}>
            تست مجدد
                  </Button>
        </Link>
      </div>
    )
  }
}
export default Buttons;
